module.exports = __webpack_public_path__ + "img/egg-3.a2bca46d.svg";